import { getCompiledDirective } from '@utils/angularBridge';
import React, { useEffect, useMemo, useRef } from 'react';

type RenderAngularDirectiveProps = {
    html: string;
    data?: any;
    as?: string;
};

export const RenderAngularDirective: React.FC<RenderAngularDirectiveProps> = ({
    html,
    data,
    as = 'div',
    ...restProps
}) => {
    const elementEl: any = useRef(null);

    const compiled = useMemo(() => getCompiledDirective(html), [html]);

    useEffect(() => {
        elementEl.current.replaceChildren(compiled.element.get(0));

        return () => {
            // compiled.scope.$destroy();
        };
    }, [compiled]);

    useEffect(() => {
        compiled.scope.$data = data;

        if (!compiled.scope.$$phase) {
            const timeoutId = setTimeout(() => compiled.scope.$apply());

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [compiled, data]);

    const As = as;
    return (
        // @ts-ignore
        <As ref={elementEl as any} {...restProps} />
    );
};
